import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@pulsarml/avalon-ui';
import { Translate } from '@utils/i18n';
import { useAuth } from '_clean-code/api/hooks/useAuth';

export const NoMachineGroupsPage = () => {
  const { logout } = useAuth();

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-h-screen tw-bg-gray-50">
      <div className="tw-bg-white tw-p-8 tw-rounded-md tw-shadow-md tw-flex tw-flex-col tw-items-center tw-max-w-md tw-text-center">
        <ShieldAlert className="tw-h-12 tw-w-12 tw-text-amber-500 tw-mb-4" />
        <div className="tw-text-xl tw-font-semibold tw-text-gray-900 tw-mb-2">
          <Translate value="no_machine_groups_assigned_title" />
        </div>
        <div className="tw-text-gray-600 tw-mb-6">
          <Translate value="no_machine_groups_assigned_description" />
        </div>
        <Button onClick={() => logout.mutate()}>
          <Translate value="logout" />
        </Button>
      </div>
    </div>
  );
};

export default NoMachineGroupsPage;
